import { FC } from 'react';
import { ICaremapNote } from '../notes/model/NotesClient';
import dayjs from 'dayjs';
import { createUseStyles } from 'react-jss';
import { IonItem } from '@ionic/react';
import { mediaMaxWidth } from '../theme/utils';
import { ReactionsRow } from './reactions/ReactionsRow';
import { CommunityPost } from './CommunityPost';
import { AttachmentList } from '../notes/generic-notes/attachments/AttachmentList';
import { IRecording } from '../appointments/recording/RecordingState';
import { CareMapNotesListItemRecording } from '../notes/note-list/CareMapNotesListItem';

const useStyles = createUseStyles({
    feedContainer: {
        marginTop: 20
    },

    itemWrapper: {
        cursor: 'pointer',
        marginBottom: 34,

        [mediaMaxWidth.sm]: {
            '& ion-item::part(native)': {
                paddingLeft: 0
            }
        }
    },

    item: {
        '--inner-padding-end': '0px',
        '--border-radius': '8px'
    }
});

// NOTE: currently "posts" are actually ICaremapNote(s)

export type ICommunityFeedListProps = {
    posts?: ICaremapNote[];
    addComment: (post: ICaremapNote) => void;
    postClick: (post: ICaremapNote) => void;
};

export const CommunityFeedList: FC<ICommunityFeedListProps> = ({ posts, addComment, postClick }) => {
    const classes = useStyles();

    // order by createdAt desc
    posts = (posts || []).sort((n1, n2) => dayjs(n1.createdAt).isAfter(n2.createdAt) ? -1 : 1);

    return (
        <div data-type="community-feed-list" className={classes.feedContainer}>
            {posts.map(post => {
                const recording = post.otherAttributes.recording as IRecording;
                return (
                    <div
                        key={post.noteId}
                        data-type="post-item"
                        data-node-id={post.noteId}
                        className={classes.itemWrapper}
                    >
                        <IonItem
                            lines="none"
                            button
                            data-id={post.noteId}
                            className={classes.item}
                            onClick={() => postClick(post)}
                        >
                            <div style={{width: '100%'}}>
                                <CommunityPost post={post} />

                                {!recording && (
                                    <AttachmentList
                                        note={post}
                                        attachments={post.attachments}
                                        marginBottom={12}
                                    />
                                )}

                                <div style={{marginBottom: 12}}>
                                    <CareMapNotesListItemRecording recording={recording} />
                                </div>
                            </div>
                        </IonItem>

                        <ReactionsRow
                            post={post}
                            addCommentHandler={addComment}
                            commentCntClickHandler={postClick}
                        />
                    </div>
                );
            })}
        </div>
    );
};
